import RequestHandler from "../RequestHandler";
import ProductPaginationResponse from "../../features/Products/interfaces/ProductListResponse";
import {ServiceInterface} from "../../interfaces/ServiceInterface";
import CategoryResponse from "../../features/Categories/interfaces/CategoryResponse";
import CheckResponse from "../../features/Invoice/interface/checkResponse";
import PriceInterface from "../../features/Invoice/interface/priceInterface";
import AppSettingController from "../../features/Main/controller/AppSettingController";
import MarketSettingLocalStorage from "../../features/Main/interface/MarketSettingLocalStorage";
import {get} from "lodash";
import marketSettingLocalStorage from "../../features/Main/interface/MarketSettingLocalStorage";

export default class LocalService implements ServiceInterface {
    url: string = ''

    constructor() {
        const setting = AppSettingController.getSetting() as marketSettingLocalStorage;
        this.url = get(setting, "baseUrl", "")
    }

    async getProducts(shopId: string, categoryId: string): Promise<ProductPaginationResponse> {
        return RequestHandler.get(`${shopId}/products?category_id=${categoryId}`)
    }

    categories(shopId: string): Promise<CategoryResponse> {
        return RequestHandler.get(`/${shopId}/categories`);
    }

    checkOrders(items: {
        id: string,
        name: string,
        count: string,
        price: string
    }[], shopId: string): Promise<CheckResponse> {
        return RequestHandler.post(`${shopId}/orders/check`, {products: items}, {'Content-Type': 'application/json'})
    }

    setOrder(shopId: string, price: PriceInterface, order: {
        products: {
            count: number,
            id: string,
            name: string,
            price: string,
        }[],
        payAt: string,
        rrn?: string,
        trace?: string,
    }, desk?: string) {
        const setting = AppSettingController.getSetting() as MarketSettingLocalStorage;
        // ref_code => rrn/trace
        return RequestHandler.post(`${shopId}/orders`, {
            pay_at: order.payAt,
            products: order.products,
            status: "purchased",
            total_price: get(price, "regular", ""),
            order_id: setting.receipt,
            desk_name: desk,
            ref_code: `${get(order, "rrn", "")}/${get(order, "trace", "")}`,
        }, {'Content-Type': 'application/json'})
    }

    getBaseUrl(): string {
        return this.url
    }

    async testBaseUrl(shopId: string): Promise<boolean> {
        try {
            const response = await RequestHandler.get(`/${shopId}/products?category_id=`, {timeout: 5000});
            return response.status;
        } catch (err: any) {
            return false;
        }
    }
}